module.exports = __webpack_public_path__ + "static/media/DEFAULT_MEDIUM_AUDIO_3.26581337.mpga";